import '../global-sass/main.scss';
import React from 'react';
import { useLocationsState } from '../features/locations/locationsSlice';

import { stateKeys } from '../utils/statesKeys';
import { StateSection } from './StateSection';

const LocationsList = () => {
	const { data: locationsByState = {} } = useLocationsState();

	const sortedStates = Object.keys(locationsByState)
		.filter(Boolean)
		.sort((state1, state2) =>
			(stateKeys[state1] ?? '').localeCompare(stateKeys[state2] ?? '')
		);

	return (
		<>
			<h1 className="mb-4">All Locations</h1>
			<main className="main-locations-list">
				{sortedStates.map((state) => (
					<StateSection
						key={stateKeys[state]}
						state={stateKeys[state]}
						locations={locationsByState[state]}
					/>
				))}
			</main>
		</>
	);
};

export default LocationsList;
